import * as React from 'react';

import { Input } from '@longline/aqua-ui/inputs/Input';
import { CountryFormatter } from '@longline/aqua-ui/formatters/CountryFormatter';
import { CountryDropdown } from '@longline/aqua-ui/modules/CountryDropdown';
import { Chip } from '@longline/aqua-ui/controls/Chip';
import { Filter } from '@longline/aqua-ui/modules/Filter';
import { Form } from '@longline/aqua-ui/containers/Form';
import { StringFormatter } from '@longline/aqua-ui/formatters/StringFormatter';
import { Dropdown } from '@longline/aqua-ui/inputs/Dropdown';

import { SearchFilter } from '../ui/SearchFilter';
import { Role } from '../api/Permission';

interface IUserFilter {
  q?: string;
  country?: string;
  role?: Role;
}

interface IProps {
  filter: IUserFilter;
  onChange: (filter: IUserFilter) => void;
}

const hasFilter = (filter: IUserFilter) => 
     (filter.q != null && filter.q != "")
  || filter.country != null;

const UserFilter = (props: IProps) => {

  const handleChange = (name: string, value: any) => {
    const newFilter: IUserFilter = {...props.filter};
    (newFilter as any)[name] = value;
    props.onChange(newFilter);
  }  
      
  return (
    <SearchFilter>
      <SearchFilter.Chips>
        {props.filter.country != null && 
          <Chip onClick={() => handleChange("country", null)}>
            <CountryFormatter type='both' value={props.filter.country}/>
          </Chip>}        
        {props.filter.role != null && 
          <Chip onClick={() => handleChange("role", null)}>
            <StringFormatter type='capitalize' value={props.filter.role}/>
          </Chip>}                      
      </SearchFilter.Chips>
      <SearchFilter.Controls>
        <Input fluid clearable value={props.filter.q} type="text" placeholder="Filter users by name" autocomplete="off" onChange={(value) => handleChange("q", value)}/>
        <Filter active={hasFilter(props.filter)}>
          <Form.Field
            label="Country"
            name="country"
            value={props.filter.country} 
            wrapper='box'
            onChange={(value) => handleChange("country", value)}
            control={<CountryDropdown clearable/>}
            hint="Filter by country"
          />     
          <Form.Field
            label="Role"
            name="role"
            value={props.filter.role} 
            wrapper='box'
            onChange={(value) => handleChange("role", value)}
            control={<Dropdown data={[ Role.Admin, Role.PowerUser ]} label={(item: Role) => <StringFormatter type='capitalize' value={item}/>} placeholder="Role" clearable>
                <Dropdown.Column>{(item: Role) => <StringFormatter type='capitalize' value={item}/>}</Dropdown.Column>
              </Dropdown>}
            hint="Filter by role"
          />                   
        </Filter>          
      </SearchFilter.Controls>
    </SearchFilter>
  )
}

export { UserFilter, IUserFilter, hasFilter }
